// extracted by mini-css-extract-plugin
export default {"icon--medium":"AxSKbNG","icon--small":"dqOPXxB"};